export default {
  selection: false,
  columns: [
    // 表格列的配置
    {
      label: "中文名",
      prop: "name_ch",
    },
    {
      label: "英文名",
      prop: "name_en",
    },
    {
      label: "识别码",
      prop: "code",
    },
    {
      label: "排序",
      prop: "sort",
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      options: { 1: "有效", 0: "关闭" },
    },
    {
      label: "备注",
      prop: "remark",
      mustFill: true,
    },
  ],
  actions: {
    // 表格操作列的配置
    fixedWidth: 110, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
    list: [
      {
        label: "编辑",
        event: "edit",
        displayRule: () => {
          return true;
        },
      },
      {
        label: "删除",
        event: "del",
        displayRule: () => {
          return true;
        },
      },
    ],
  },
  forms: [
    {
      label: "中文名",
      prop: "name_ch",
      type: "input",
      rule: [
        {
          required: true,
          message: "请输入等级中文名",
          trigger: "blur",
        },
      ],
    },
    {
      label: "英文名",
      prop: "name_en",
      type: "input",
      rule: [
        {
          required: true,
          message: "请输入等级英文名",
          trigger: "blur",
        },
      ],
    },
    {
      label: "级别码",
      prop: "code",
      type: "input",
      rule: [
        {
          required: true,
          message: "请输入等级码：1,2,3...",
          trigger: "blur",
        },
        {
          pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
          message: "请输入非负数",
        },
      ],
    },
    {
      label: "排序",
      prop: "sort",
      type: "input",
      rules: [
        {
          pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
          message: "请输入非负数",
        },
      ],
    },
    {
      label: "状态:",
      prop: "status",
      type: "switch",
      modelValue: "1",
      activeText: "是",
      inactiveText: "否",
      rule: [{ required: true }],
    },
    {
      label: "备注",
      prop: "remark",
      type: "input",
      inputType: "textarea",
    },
  ],
};
